import BranchDataCard from './BranchDataCard';

export default BranchDataCard;
